import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { brand } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await register(form); toast.success("Akun berhasil dibuat"); navigate("/"); }
    catch (e2) { setErr(errMsg(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="grid place-items-center p-6 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-sm">
          <Link to="/" className="font-serif text-3xl font-bold text-rl-ink lg:hidden">{brand?.brand_name || "RELOVA"}</Link>
          <h1 className="mt-6 font-serif text-3xl font-bold text-rl-ink">Buat Akun</h1>
          <p className="text-sm text-rl-muted mt-1">Gabung marketplace preloved terpercaya.</p>
          {err && <div className="mt-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{err}</div>}
          <div className="mt-6 space-y-4">
            <input data-testid="reg-name" required value={form.name} onChange={set("name")} placeholder="Nama lengkap" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
            <input data-testid="reg-email" type="email" required value={form.email} onChange={set("email")} placeholder="Email" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
            <input data-testid="reg-phone" value={form.phone} onChange={set("phone")} placeholder="No. HP (opsional)" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
            <input data-testid="reg-password" type="password" required value={form.password} onChange={set("password")} placeholder="Kata sandi" className="w-full rounded-xl border border-rl-border bg-white px-4 py-3 text-sm outline-none focus:border-rl-primary" />
          </div>
          <button data-testid="reg-submit" disabled={loading} className="mt-6 w-full rounded-full bg-rl-primary hover:bg-rl-primaryHover text-white font-bold py-3 transition-colors disabled:opacity-50">
            {loading ? "Memproses..." : "Daftar"}</button>
          <p className="mt-4 text-sm text-center text-rl-muted">Sudah punya akun? <Link to="/login" className="text-rl-primary font-semibold">Masuk</Link></p>
        </form>
      </div>
      <div className="hidden lg:block relative bg-rl-primary order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1559563458-527698bf5295?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 grid place-items-center p-12">
          <div className="text-white max-w-md">
            <div className="font-serif text-4xl font-bold">{brand?.brand_name || "RELOVA"}</div>
            <p className="mt-4 text-xl text-white/90 font-serif italic">Jual yang sudah tidak kamu pakai. Temukan yang ingin kamu miliki.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
